import React from "react";
import Skeleton from "../skeleton";
import * as S from "./styles";

const SkeletonListItem = () => {
  return (
    <S.ListItem>
      <div>
        <Skeleton type="radioInput" />
      </div>
      <div className="texts">
        <Skeleton type="radioInputLabel" />
      </div>
    </S.ListItem>
  );
};
export default SkeletonListItem;
